import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Services, Acesso} from './../../shared';
import { UntypedFormBuilder } from '@angular/forms';
import {AcessoFormGroup} from './acesso.formgroup'
import {ErroApp} from './../../shared/models/erro-app.model'

@Component({
    selector: 'app-acesso',
    templateUrl: './acesso.component.html'
})

export class AcessoComponent implements OnInit
{
    private acesso : Acesso;

    formulario: AcessoFormGroup;

    constructor(private activeRoute: ActivatedRoute, protected svc: Services, protected fb: UntypedFormBuilder)
    {
        this.formulario = new AcessoFormGroup(this.fb);
        this.acesso = new Acesso();
    }

    ngOnInit() {

        const parametros = this.activeRoute.snapshot.queryParams;
        this.acesso.token = parametros.token;
        this.acesso.idDocumentoTramite = parametros.idDocumentoTramite;

    }

    realizarAcessoExterno() {
        this.acesso.codigoAcesso = this.formulario.formGroup.controls[this.formulario.campos.codigoAcesso.name].value;
        this.acesso.login = this.formulario.formGroup.controls[this.formulario.campos.login.name].value;
        this.acesso.senha = this.formulario.formGroup.controls[this.formulario.campos.senha.name].value;

        this.svc.acessoExternoService.realizarAcessoExterno(this.acesso).then((acesso) =>
        {
            this.svc.logger.info('[realizarAcessoExterno] Acesso externo OK', acesso);
            this.svc.logger.info('[realizarAcessoExterno] Redirecionando para ' + acesso.urlDestino);
            window.location.replace(acesso.urlDestino);
            return;

        })
        .catch((err: any) => {
            this.svc.logger.error('[realizarAcessoExterno] Erro ao realizar acesso.', err);
            this.alertarErro('Erro', `Não foi possível realizar acesso ao trâmite.`, err);
        });

    }

    protected alertarErro(titulo: string, cabecalho: string, err: any)
    {
        if (err instanceof ErroApp)
        {
            this.svc.bnAlertService.alertaErro(titulo, err.cabecalho + ' ' + cabecalho, err.listaComentarios);
            return;
        }
        if (err == null)
        {
            this.svc.bnAlertService.alertaErro(titulo, cabecalho);
            return;
        }
        this.svc.bnAlertService.alertaErro(titulo, cabecalho, err);
    }
}





